import { h } from "harmaja"
import * as L from "lonna"

// Theme: "light" | "dark" override stored in localStorage, otherwise follow the OS.
// The CSS reads html.dark / html.light plus prefers-color-scheme (see variables.scss).
type Theme = "light" | "dark" | "system"
const stored = (): Theme =>
    localStorage.theme === "dark" || localStorage.theme === "light" ? localStorage.theme : "system"
export const theme = L.atom<Theme>(stored())

const systemDark = () => window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false
export const isDark = L.view(theme, (t) => (t === "system" ? systemDark() : t === "dark"))

theme.forEach((t) => {
    if (t === "system") delete localStorage.theme
    else localStorage.theme = t
    document.documentElement.classList.toggle("dark", t === "dark")
    document.documentElement.classList.toggle("light", t === "light")
})

export const toggleTheme = () => theme.set(isDark.get() ? "light" : "dark")

export const ThemeToggle = () => (
    <a
        className="theme-toggle"
        title={L.view(isDark, (d) => (d ? "Switch to light mode" : "Switch to dark mode"))}
        onClick={toggleTheme}
    >
        {L.view(isDark, (d) => (d ? "☀" : "☾"))}
    </a>
)
